import React, { useEffect, useState } from "react";
import apiClient from '../../../services/apiClient';

const EventProductsModal = ({ eventid, type, onSelect, onClose }) => {
  const [items, setItems] = useState([]);

useEffect(() => {
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.user?.id;

  if (!userId) return;

  const fetchItems = async () => {
    try {
      const endpoint =
        type === "Products"
          ? `/products_list`
          : `/packages_list`;

      const response = await apiClient.post(endpoint, { user_id: userId });
      const items = (response.data || []).map((it) => ({
        ...it,
        image: it.image1 || it.image2 || it.image3 || null,
      }));

      setItems(items);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  fetchItems();
}, [type]);


  // build edit url
  const getEditUrl = (id) => {
    if (type === "Products") {
      return `/edit-product/${id}`;
    }
    return `/edit-package/${id}`;
  };

  return (
    <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header bg-primary">
            <h5 className="modal-title text-white w-100 text-center">
              Select {type}
            </h5>
            <button type="button" className="close" onClick={onClose}>
              <span aria-hidden="true" className="modal_button">
                <i className="fas fa-close"></i>
              </span>
            </button>
          </div>

          {/* Body */}
          <div
            className="modal-body py-4 px-4"
            style={{ background: "#f1f5f9" }}
          >
            <table className="table table-borderless modal-tb">
              <thead>
                <tr>
                  <th>PHOTO</th>
                  <th>NAME</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {items.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No {type.toLowerCase()} found.
                    </td>
                  </tr>
                ) : (
                  items.map((item) => (
                    <tr key={item.id}>
                      <td>
                        {item.image ? (
                          <img
                            src={
                              `${process.env.REACT_APP_BACKEND_URL}/` +
                              item.image
                            }
                            alt={item.name}
                            style={{
                              width: "50px",
                              height: "50px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <i className="fa fa-image fa-2x text-secondary" />
                        )}
                      </td>
                      <td
                        style={{
                          maxWidth: "150px",
                          fontSize: "16px",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        <a href={getEditUrl(item.id)}>{item.name}</a>
                      </td>

                      <td>
                        {/* Select button */}
                        <button
                          className="btn btn-sm btn-primary me-2"
                          onClick={() => onSelect(item)}
                        >
                          Select
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventProductsModal;
